import { usePersistedAdminEnvironment } from "../hooks/usePersistedAdminEnvironment.js";
import type { AdminEnvironment } from "../lib/adminEnvironmentStorage.js";

const options: ReadonlyArray<{ value: AdminEnvironment; label: string }> = [
  { value: "sandbox", label: "Sandbox" },
  { value: "production", label: "Production" }
];

export const AdminEnvironmentSwitch = () => {
  const [environment, setEnvironment] = usePersistedAdminEnvironment();

  return (
    <div className="admin-env-switch" role="group" aria-label="Environment">
      {options.map((option) => {
        const isActive = environment === option.value;
        return (
          <button
            key={option.value}
            type="button"
            className={
              isActive
                ? `admin-env-switch-btn admin-env-switch-btn--${option.value} admin-env-switch-btn--active`
                : `admin-env-switch-btn admin-env-switch-btn--${option.value}`
            }
            aria-pressed={isActive}
            onClick={() => {
              setEnvironment(option.value);
            }}
          >
            <span className="admin-env-switch-dot" aria-hidden />
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
